import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import {
  RegisterMemberCardStaffPayload,
  RegisterMemberCardStaffResultDto,
} from '../../../models/cityparking/register-member-card-staff.model';

@Injectable({
  providedIn: 'root',
})
export class ApiRegisterMemberCardStaffService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  registerMemberCardByStaff(
    payload: RegisterMemberCardStaffPayload
  ): Observable<RegisterMemberCardStaffResultDto> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<RegisterMemberCardStaffResultDto>(
      '/backoffice/registerMemberCardByStaff',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'registerMemberCardByStaff',
        token,
        headerOnly: false,
        body: payload,
      }
    );
  }
}
